// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cQfk","tabsBox":"styles_tabsBox__2f45U","createButton":"styles_createButton__1Nr3X"};